import { CfCellData } from '../../../CfDataGridProps';
import { ValueGetter } from '../../DataGridTableView/CfDataGridTableViewProps';
import { CfDataGridCell } from '../cell/CfDataGridCell';
import { CfDataGridCellById } from '../cell/CfDataGridCellById';
import { CfDataGridHeaderCell } from '../cell/CfDataGridHeaderCell';
import { CfDataGridCellsBaseProps } from '../cell/common';

export function getHeaderCellsData<TItem>(valueGetters: ValueGetter<TItem>[]): CfCellData[] {
  const cells: CfCellData[] = [];
  const columnsLength = valueGetters.length;
  return valueGetters.map((getter, columnIndex) => ({
    id: undefined,
    type: 'header',
    content: <CfDataGridHeaderCell getter={getter} columnIndex={columnIndex} columnsLength={columnsLength} />,
  }));

  return cells;
}

export function getCellsDataByItem<TItem>(
  props: CfDataGridCellsBaseProps,
  itemId: string | undefined,
  item: TItem | undefined,
  valueGetters: ValueGetter<TItem>[]
): CfCellData[] {
  return valueGetters.map((getter, columnIndex) => ({
    id: itemId,
    type: 'body',
    content: <CfDataGridCell {...props} item={item} getter={getter} columnIndex={columnIndex} />,
  }));
}

export function getCellsDataByItemId<TItem, TAppState>(
  props: CfDataGridCellsBaseProps,
  itemId: string | undefined,
  itemSelector: (itemId: string, store: TAppState) => TItem | undefined,
  useSelector: (itemSelector: (state: TAppState) => TItem | undefined) => TItem | undefined,
  valueGetters: ValueGetter<TItem>[]
): CfCellData[] {
  return valueGetters.map((getter, columnIndex) => ({
    id: itemId,
    type: 'body',
    content: (
      <CfDataGridCellById
        {...props}
        itemId={itemId}
        getter={getter}
        columnIndex={columnIndex}
        itemSelector={itemSelector}
        useSelector={useSelector}
      />
    ),
  }));
}
